/**
 * Club id on event payloads (shape differs by endpoint).
 */
export function getEventClubId(item) {
  if (!item || typeof item !== "object") return null;
  const direct = item.clubid ?? item.clubId;
  if (direct != null && direct !== "") return String(direct);
  if (item.club && typeof item.club === "object") {
    const id = item.club._id ?? item.club.id;
    if (id != null && id !== "") return String(id);
  }
  return null;
}

/**
 * Club managers: keep only events owned by the managed club (if API returns extras).
 */
export function eventsForManagedClubOnly(items, managedClubId) {
  if (!managedClubId || !Array.isArray(items)) return Array.isArray(items) ? items : [];
  const mid = String(managedClubId);
  return items.filter((item) => {
    const cid = getEventClubId(item);
    return cid != null && cid === mid;
  });
}

/**
 * Query for GET /event/currentEvents and /event/pastEvents as club staff.
 * clubid must match the user's managed club (same string as JWT / profile).
 */
export function buildStaffClubEventQuery(managedClubId) {
  if (managedClubId == null || managedClubId === "") return null;
  const id = String(managedClubId).trim();
  if (!id || id === "undefined") return null;
  return { clubid: id };
}

/**
 * Ticket status / in-queue: use event id only; club manager auth is enforced server-side via JWT.
 * Do not pass clubid here — it can over-filter and return an empty list for managers.
 */
export function buildStaffEventTicketRequest(eventId) {
  if (eventId == null || eventId === "") return null;
  return String(eventId);
}
